import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { ProfilePage } from "@/pages/profile/overview"

// `card` opens that card's reactions on arrival: the reactions popup has no
// route of its own, so this is the only way a notification can address it.
const searchSchema = z.object({
	card: z.number().optional().catch(undefined),
})

export const Route = createFileRoute("/_authenticated/profile/")({
	validateSearch: searchSchema.parse,
	component: ProfilePage,
})
